import { Button as BaseButton } from './Button'
import type { ButtonComponent } from './types'
import * as variants from './variants'

const Button = BaseButton as ButtonComponent
Object.assign(Button, variants)

export { Button }
